<div class="root-div">
  <p-select
    [options]="projects"
    [(ngModel)]="selectedProject"
    name="selectedProject"
    optionLabel="name"
    class="small-select margin"
    [filter]="true"
    (onChange)="onProjectSelected($event.value.id)"
    filterPlaceholder="Search a project">
  </p-select>
</div>
